import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import { useSelector } from "react-redux";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import { IRepoV2ReduxState } from "repoV2/features/Common/modules/Reducer/Reducer.interface";
import { IWebinarSessionsProps } from "./WebinarSession.interfaces";

export const useWebinarSessionsBaseProps = (): IWebinarSessionsProps => {
    const { listingUuid } = useCheckoutBasicDetailsContext();
    const sessions =
        useSelector(
            (state: IRepoV2ReduxState) =>
                state.checkoutPages.listingDetails?.[listingUuid]
                    ?.sessionDetails?.data?.slots
        ) || [];

    return {
        sessions,
        sessionsCount: sessions.length,
        hide: checkIsArrayEmpty(sessions),
    };
};
